export default __webpack_public_path__ + "static/2-second-draft-423e14df5fb29fb44dfb3b69ff81e7ec.jpg";